/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Use_Cases_Launch_TitleInputs */

const en_directory_taxonomy_use_cases_launch_title = /** @type {(inputs: Directory_Taxonomy_Use_Cases_Launch_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch a product`)
};

const zh_directory_taxonomy_use_cases_launch_title = /** @type {(inputs: Directory_Taxonomy_Use_Cases_Launch_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布产品`)
};

/**
* | output |
* | --- |
* | "Launch a product" |
*
* @param {Directory_Taxonomy_Use_Cases_Launch_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_use_cases_launch_title = /** @type {((inputs?: Directory_Taxonomy_Use_Cases_Launch_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Use_Cases_Launch_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_use_cases_launch_title(inputs)
	return zh_directory_taxonomy_use_cases_launch_title(inputs)
});
export { directory_taxonomy_use_cases_launch_title as "directory.taxonomy.use-cases.launch.title" }